module.exports = __webpack_public_path__ + "static/media/smile2.9a633c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile2.png
// module id = 75
// module chunks = 0